import { useLanguage } from "@/lib/i18n";
import { LegalPageLayout } from "./LegalPageLayout";

export default function PrivacyPolicyPage() {
  const { t } = useLanguage();

  return (
    <LegalPageLayout titleKey="legal.privacy.title" seoDescriptionKey="legal.privacy.seoDescription" pagePath="/privacy">
      <h1 className="text-2xl md:text-3xl font-bold mb-2">{t('legal.privacy.title')}</h1>
      <p className="text-sm text-muted-foreground mb-4">{t('legal.privacy.effectiveDate')}</p>
      <p className="text-sm text-muted-foreground mb-8 leading-relaxed">{t('legal.privacy.intro')}</p>

      <Section title={t('legal.privacy.s1.title')}>
        <P>{t('legal.privacy.s1.1')}</P>
        <P>{t('legal.privacy.s1.2')}</P>
      </Section>

      <Section title={t('legal.privacy.s2.title')}>
        <Pre>{t('legal.privacy.s2.content')}</Pre>
      </Section>

      <Section title={t('legal.privacy.s3.title')}>
        <Pre>{t('legal.privacy.s3.content')}</Pre>
      </Section>

      <Section title={t('legal.privacy.s4.title')}>
        <Pre>{t('legal.privacy.s4.content')}</Pre>
      </Section>

      <Section title={t('legal.privacy.s5.title')}>
        <P>{t('legal.privacy.s5.content')}</P>
      </Section>

      <Section title={t('legal.privacy.s6.title')}>
        <P>{t('legal.privacy.s6.content')}</P>
      </Section>

      <Section title={t('legal.privacy.s7.title')}>
        <P>{t('legal.privacy.s7.content')}</P>
      </Section>

      <Section title={t('legal.privacy.s8.title')}>
        <P>{t('legal.privacy.s8.content')}</P>
      </Section>

      <Section title={t('legal.privacy.s9.title')}>
        <P>{t('legal.privacy.s9.content')}</P>
      </Section>

      <Section title={t('legal.privacy.s10.title')}>
        <P>{t('legal.privacy.s10.content')}</P>
      </Section>

      <Section title={t('legal.privacy.s11.title')}>
        <P>{t('legal.privacy.s11.content')}</P>
      </Section>

      {/* Microsoft Clarity Disclaimer */}
      <div className="mt-8 p-4 bg-muted/50 rounded-lg border border-border/30">
        <p className="text-xs text-muted-foreground leading-relaxed">{t('legal.privacy.clarity')}</p>
      </div>
    </LegalPageLayout>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-8">
      <h2 className="legal-heading text-lg font-semibold mb-3">{title}</h2>
      {children}
    </section>
  );
}

function P({ children }: { children: React.ReactNode }) {
  return <p className="legal-content text-sm text-muted-foreground leading-relaxed mb-2">{children}</p>;
}

function Pre({ children }: { children: React.ReactNode }) {
  return <p className="legal-content text-sm text-muted-foreground leading-relaxed mb-2 whitespace-pre-line">{children}</p>;
}
